import { render, staticRenderFns } from "./MyGame.vue?vue&type=template&id=d73637ee&scoped=true"
import script from "./MyGame.vue?vue&type=script&lang=js"
export * from "./MyGame.vue?vue&type=script&lang=js"
import style0 from "./MyGame.vue?vue&type=style&index=0&id=d73637ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d73637ee",
  null
  
)

export default component.exports